var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-dialog",
    {
      attrs: {
        width: "600",
        scrollable: ""
      },
      model: {
        value: _vm.dialog,
        callback: function callback($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "gg-card",
        [
          _c(
            "gg-toolbar",
            {
              on: {
                close: _vm.close
              }
            },
            [
              _vm._v(
                " Add " +
                  _vm._s(_vm.type) +
                  " record for " +
                  _vm._s(_vm.domain) +
                  " "
              )
            ]
          ),
          _c(
            "gg-card-text",
            [
              _c("record-hint", {
                attrs: {
                  type: _vm.type,
                  domain: _vm.domain,
                  model: _vm.model
                }
              }),
              _vm.type === "A"
                ? _c("a-record-form", {
                    on: {
                      "send-data": _vm.retrieveData
                    }
                  })
                : _vm.type === "AAAA"
                ? _c("a-a-a-record-form", {
                    on: {
                      "send-data": _vm.retrieveData
                    }
                  })
                : _vm.type === "CNAME"
                ? _c("c-name-record-form", {
                    on: {
                      "send-data": _vm.retrieveData
                    }
                  })
                : _vm.type === "CAA"
                ? _c("c-a-a-record-form", {
                    on: {
                      "send-data": _vm.retrieveData
                    }
                  })
                : _vm.type === "SRV"
                ? _c("s-r-v-record-form", {
                    on: {
                      "send-data": _vm.retrieveData
                    }
                  })
                : _vm.type === "TXT"
                ? _c("t-x-t-record-form", {
                    on: {
                      "send-data": _vm.retrieveData
                    }
                  })
                : _vm.type === "MX"
                ? _c("m-x-record-form", {
                    attrs: {
                      domain: _vm.domain
                    },
                    on: {
                      "send-data": _vm.retrieveData
                    }
                  })
                : _vm.type === "DMARC"
                ? _c("d-m-a-r-k-record-form", {
                    attrs: {
                      domain: _vm.domain
                    },
                    on: {
                      "send-data": _vm.retrieveData
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "v-card-actions",
            {
              staticClass: "justify-end"
            },
            [
              _c(
                "gg-btn",
                {
                  attrs: {
                    secondary: ""
                  },
                  on: {
                    click: _vm.close
                  }
                },
                [_vm._v(" Close ")]
              ),
              _c(
                "gg-btn",
                {
                  attrs: {
                    loading: _vm.loading
                  },
                  on: {
                    click: _vm.addRecord
                  }
                },
                [_vm._v(" Add ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }